export const BELL_ANIMATION = `
        0%,5% {
          transform: rotate(0deg);
        }
        8%,
        14%,
        20% {
          transform: rotate(-24deg);
        }
        11%,
        17% {
          transform: rotate(24deg);
        }

        23% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(0deg);
        }
`;

export const BORDER_ANIMATION = `
        0% {
          opacity: 0.1;
          transform: translate(-50%, -50%) rotate(115deg);
        }
        8%{
          opacity: 1;
        }
        20% {
          transform: translate(-50%, -50%) rotate(320deg);
          opacity: 1;
        }
        35%{
          opacity: 0.6;
        }
        40% {
          transform: translate(-50%, -50%) rotate(475deg);
          opacity: 0;
        }
        100% {
          transform: translate(-50%, -50%) rotate(475deg);
          opacity: 0;
        }
`;

export const SHIMMER_ANIMATION = `
    0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;
